import React from 'react';
import IconButtonV2 from '@/ctComponents/IconButton/IconButtonV2';
import VideoEmbed from './video-template';
import IconButton from '@/ctComponents/IconButton';
import { Icon } from '@/components/Icon';
import { Icons } from '@/assets';

export const VideoCard = ({
  videoData,
  isAdmin,
  onEdit,
  onDelete,
  onViewersList,
  isUser,
}) => {
  return (
    <div className="bg-white relative border shadow-custom-plan border-border-tertiary border-solid rounded-lg p-4 lg:p-6">
      {isAdmin && (
        <div className="lg:absolute top-6 right-6 lg:left-6 flex items-center gap-2">
          <IconButtonV2 icon="pen" onClick={onEdit} />
          <IconButtonV2 icon="deleteIcon" onClick={onDelete} />
          <IconButton
            icon="users"
            onClick={onViewersList}
            text="Viewers List"
            color="#717784"
            style={{
              backgroundColor: 'white',
              height: 32,
              fontFamily: 'Averta',
            }}
            size="normal"
          />
        </div>
      )}
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-6">
        <div className="flex-1 flex flex-col lg:justify-between gap-4">
          <h3
            className={`flex items-center gap-2 text-base lg:text-lg -bold text-primary-text  m-0 ${
              isAdmin && 'mt-12'
            }`}>
            {isAdmin && (
              <span className="text-sm lg:text-md text-secondary-text bg-gray-700 px-3 py-1 rounded-full flex items-center gap-1">
                {videoData.order_number}
              </span>
            )}{' '}
            {videoData.title}
          </h3>

          <p className="text-sm lg:text-sm m-0 text-secondary-text capitalize line-clamp-4">
            {videoData.description}
          </p>
          <div className="flex flex-wrap gap-2">
            {videoData.tags.split(',').map((tag, tagIndex) => (
              <span
                key={tagIndex}
                className="bg-gray-700 px-3 py-1 rounded-full flex items-center gap-1">
                <span className="w-1 h-1 bg-inactive-text rounded-full" />
                <span className="text-inactive-text text-xs -bold">{tag}</span>
              </span>
            ))}
          </div>
        </div>

        <div className="max-w-428 w-full relative  h-60 flex items-center justify-center bg-gray-5000 rounded-lg ">
          {isAdmin && (
            <span
              className={`z-10 rounded-full absolute top-3 right-3 text-11 font-bold flex items-center gap-1 justify-center px-3 py-2 ${
                videoData.status === 'ACTIVE'
                  ? 'bg-success-light text-success'
                  : 'bg-white  text-gray-600'
              }`}>
              <Icon
                src={videoData.status === 'ACTIVE' ? Icons.eye : Icons.eyeClose}
                width={16}
                height={16}
                color={videoData.status === 'ACTIVE' ? '#178C4E' : '#717784'}
              />
              {videoData.status}
            </span>
          )}
          <VideoEmbed video={videoData} isUser={isUser} />
        </div>
      </div>
    </div>
  );
};
